import React from "react";
import { Button, Modal } from "react-bootstrap";

const ENGModalFooter = ({ closeMethod , type, title, }: { closeMethod: any, type?: any, title?: string,  }) => {
  return (
    <Modal.Footer style={styles.bgGrey}>
      {
        type==="submit"?          
          <Button onClick={closeMethod} type={type} style={styles.button}>
              {title}
          </Button>:
         
          <Button onClick={closeMethod} style={styles.button}>
              DONE
          </Button> 

      } 


    </Modal.Footer>

  );
};

const styles = {
  bgGrey: {
    backgroundColor: "#faf9f9",
  },
  button: {
    padding: "13px 40px",
    fontFamily: "Saira",
    fontSize: "12px",
    fontWeight: 400,
    fontStretch: "normal",
    fontStyle: "normal",
    borderRadius: "0",
    backgroundColor: "#e31837",
    letterSpacing: "normal",
    border: "0px",
  },
  button1: {
    padding: "13px 20px",
    fontFamily: "Saira",
    fontSize: "12px",
    fontWeight: "500",
    fontStretch: "normal",
    fontStyle: "normal",
    borderRadius: "0",
    backgroundColor: "#ffffff",
    border:"1px solid #e31837",
    letterSpacing: "normal",    
    color:"#e31837"
  },
};

export default ENGModalFooter;
